import { render, staticRenderFns } from "./tipsPopup.vue?vue&type=template&id=168fdd18&scoped=true"
import script from "./tipsPopup.vue?vue&type=script&lang=js"
export * from "./tipsPopup.vue?vue&type=script&lang=js"
import style0 from "./tipsPopup.vue?vue&type=style&index=0&id=168fdd18&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168fdd18",
  null
  
)

export default component.exports